export const recipientTypeMap = {
  company: 'companies',
  contact: 'contacts',
  person_lead: 'leads/persons',
  company_lead: 'leads/companies',
};
